<template>
  <div>
    <!-- <ActorForm v-if="actorsStore.actorEdition.active" /> -->
    <AdminUserEditionForm v-if="adminStore.userEdition.active" />
    <ProjectForm
      v-if="projectStore.isProjectFormShown"
      :project="null"
      :isShown="projectStore.isProjectFormShown"
      :type="FormType.CREATE"
      :key="0"
      @close="projectStore.isProjectFormShown = false"
      @submitted="projectStore.isProjectFormShown = false"
    />
    <ResourceForm
      v-if="resourceStore.isResourceFormShown"
      :resource="resourceStore.editedResource ?? null"
      :isShown="resourceStore.isResourceFormShown"
      :type="
        resourceStore.editedResource
          ? resourceStore.editedResource.isValidated
            ? FormType.EDIT
            : FormType.VALIDATE
          : FormType.CREATE
      "
      :key="0"
      @close="resourceStore.isResourceFormShown = false"
      @submitted="resourceStore.isResourceFormShown = false"
    />
    <!-- <EditMessageDialog v-if="useApplicationStore().showEditMessageDialog" />
    <EditThanksDialog v-if="useApplicationStore().showEditThanksDialog" /> -->
  </div>
</template>
<script lang="ts" setup>
import AdminUserEditionForm from '@/views/admin/components/admin-members/AdminUserEditionForm.vue'
import { useAdminStore } from '@/stores/adminStore'
import ProjectForm from '@/views/projects/components/ProjectForm.vue'
import ResourceForm from '@/views/resources/components/ResourceForm.vue'
import { useProjectStore } from '@/stores/projectStore'
import { useResourceStore } from '@/stores/resourceStore'
import { FormType } from '@/models/enums/app/FormType'

const projectStore = useProjectStore()
const resourceStore = useResourceStore()
const adminStore = useAdminStore()
</script>
